import { Statements } from 'services/transactionStatement/typings'
import { StatementsActionType, TransactionStatementState } from './typings'

export const initState: TransactionStatementState = {
  response: {} as Statements,
  isLoading: false,
  error: null,
  downloadStatus: ''
}

const transactionsReducer = (
  // eslint-disable-next-line default-param-last, @typescript-eslint/default-param-last
  state: TransactionStatementState = initState,
  action: StatementsActionType
): TransactionStatementState => {
  switch (action.type) {
    case 'GET_STATEMENTS':
      return {
        ...state,
        isLoading: true
      }
    case 'GET_STATEMENTS_FULFILLED':
      return {
        ...state,
        isLoading: false,
        response: action.payload.response
      }
    case 'GET_STATEMENTS_FAILED':
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      }
    case 'GET_DOWNLOAD_STATEMENTS_FULFILLED':
      return {
        ...state,
        isLoading: false,
        downloadStatus: 'success'
      }
    case 'GET_DOWNLOAD_STATEMENTS_FAILED':
      return {
        ...state,
        isLoading: false,
        downloadStatus: 'failure'
      }
    case 'RESET_DOWNLOAD_STATEMENTS':
      return {
        ...state,
        isLoading: false,
        downloadStatus: ''
      }
    default:
      return state
  }
}

export default transactionsReducer
